export default {
  //loại ngày
  Date: 1,
  // loại số
  Number: 2,
  // loại mlns
  MLNS: 3,
  //loại số tiền
  Money: 4,
  //loại tài sản cố định
  FixedAsset: 5,

  //loại nghiệp vụ
  Cash: 6,
  //loại số lượng
  Quantity: 7,

  //loại chứng từ
  VoucherCategory: 8,

  //loại đối tượng
  ObjectCategory: 9,

  // loại đặc biệt
  Equals: 0,
};
